import React, {Component} from "react";
import {NavLink} from "react-router-dom";
import TypeNews from "../../helpers/TypeNews";

class NewsHeader extends Component {
	render() {
		const {type, isNewsFull} = this.props;

		return (
			<div className="news__header">
				<div className="news__header-links">
					{TypeNews.getTypeNews().map((item) =>
						<NavLink key={item.slug} to={`/news/type/${item.slug}`} className={isNewsFull && (type === item.slug && 'active')}>{item.name}</NavLink>)}
				</div>
			</div>
		);
	}
}

export default NewsHeader;


// WEBPACK FOOTER //
// ./src/app/pages/News/NewsHeader.js